<template>
  <a-modal
    :title="viewTitle"
    visible
    @cancel="cancel"
  >
    <ak-inputs :options="editFields" ref="inputs" v-model="record" />
    <template slot="footer">
      <a-button type="primary" @click="cancel">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'viewPage',
  data () {
    return {}
  },
  computed: {
    editFields () {
      let data = this.model.fields.filter(field => !field.hideOnEdit)
      let arr = []
      data.forEach((e) => {
        let obj = {}
        if (e.disabled) {
          obj = { ...e.schema, name: e.name, disabled: true }
        } else {
          obj = { ...e.schema, name: e.name, disabled: true }
        }
        arr.push(obj)
      })
      return arr
    }
  },
  mounted () {
  },
  methods: {
    cancel () {
      this.$emit('complete', 'cancel')
    }
  },
  props: {
    record: Object, // 当前行的数据
    model: Object, // 当前model对象
    field: Object, // 当前field对象
    viewTitle: {
      type: String,
      default: '查看'
    }
  }
}
</script>

<style scoped>

</style>
